var _polygon, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 260",
    shapeRendering: "crispEdges",
    id: "svg--desk",
    className: "svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--leather",
    points: "0,110 320,110 320,260 310,260 310,130 10,130 10,260 0,260"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "desk__plant"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--green",
    points: "10,40 40,40 40,50 50,50 50,70 0,70 0,50 10,50"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--light-brown",
    points: "20,70 30,70 30,80 20,80"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--stubble",
    points: "10,80 40,80 40,110 10,110"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "desk__mug"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--black",
    points: "180,110 150,110 150,100 140,100 140,90 150,90 150,80 180,80"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "desk__monitor"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--light-gray",
    points: "320,0 320,80 200,80 200,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--shadow-gray",
    points: "270,80 250,80 250,100 270,100"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--light-gray",
    points: "290,100 290,110 230,110 230,100"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--gray",
    points: "270,20 270,30 250,30 250,50 270,50 270,40 260,40 260,20"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/desk.6509c11da50da2f4a2d63ad32d2e060c.svg";
export { ForwardRef as ReactComponent };